import litraBase from "../../../../../pages/seating/seatmap-images/bpa75_response.png";
import litraWithSeats from "../../../../../pages/seating/seatmap-images/bpa75_ex1.png";
import * as React from 'react';
export default {
  litraBase,
  litraWithSeats,
  React
};